import axios from 'axios'
import { getToken, clearAuth } from '@/utils/auth'

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL,
  timeout: 10000
})

service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

service.interceptors.response.use(
  response => {
    const res = response.data
    if (res.code === 401 || res.code === 20003) {
      clearAuth()
      location.href = '/login'
    }
    return res
  },
  error => {
    if (error.response && error.response.status === 401) {
      clearAuth()
      location.href = '/login'
    }
    return Promise.reject(error)
  }
)

export default service